export default __webpack_public_path__ + "static/media/eb-ultra-blk-poster-2.19818e09.jpg";